// @ts-nocheck
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { inject, observer } from '../../../stores/mobx-compat';
import { withRouter } from '../../../router-compat';

import PageHeader from '../../ui/PageHeader';
import Overview from './Overview';
import Individual from './Individual';
import FormsModal from './FormsModal';

import { modalTypes } from '../../../enums';

class Forms extends Component {
  state = {
    urlSelection: null,
    modalAction: null,
    modalOpen: false,
  }

  modalOnClose = () => this.setState({ modalOpen: false });
  openModal = () => this.setState({ modalOpen: true });

  addBtnHandler = () => this.setState({
    modalOpen: true,
    modalAction: modalTypes.add,
    urlSelection: null,
  });

  removeBtnHandler = (url) => this.setState({
    modalOpen: true,
    modalAction: modalTypes.remove,
    urlSelection: url,
  });

  editBtnHandler = (url) => {
    this.setState({ urlSelection: url, modalAction: modalTypes.edit });
    const safePath = encodeURIComponent(url);
    this.props.history.push({
      pathname: `/forms/${safePath}`,
      state: { data: url },
    });
  }

  backBtnHandler = () => this.setState({ urlSelection: null });

  render() {
    const { urlSelection, modalAction, modalOpen } = this.state;
    return (
      <>
        <PageHeader
          eyebrow="Forms"
          title={<>Track every <em>form</em> on your site.</>}
          sub="Add the URLs you'd like to monitor. We watch installs, captures, and deliveries."
        />
        {urlSelection !== null && modalAction === modalTypes.edit ? (
          <Individual selection={urlSelection} back={this.backBtnHandler} />
        ) : (
          <Overview
            add={this.addBtnHandler}
            remove={this.removeBtnHandler}
            edit={this.editBtnHandler}
          />
        )}
        <FormsModal
          open={modalOpen}
          onClose={this.modalOnClose}
          action={modalAction}
          url={urlSelection}
        />
      </>
    );
  }
}

export default withRouter(inject('store')(observer(Forms)));
